import { Route, Routes } from "react-router-dom";
import Home4Page from "../app/components/home/index4";
import ContactPage from "../app/components/misc/contact-us";
import FaqPage from "../app/components/misc/faq";
import Error404Page from "../app/components/misc/error404";
import BlogGridPage from "../app/components/blogs/blog-grid";
import BlogsDetailPage from "../app/components/blogs/blog-detail";
import ServicesDetailPage from "../app/components/services/services-detail";
import CorporateIdentityPage from "../app/components/misc/corporate-identity";
import MaritimeLawService from "../app/components/services/maritime-law-service";
import TaxLawService from "../app/components/services/tax-law-services";
import CustomsLawService from "../app/components/services/customs-law-service";
import CommercialLawServices from "../app/components/services/commercial-law-services";
import InsuranceServices from "../app/components/services/insurance-services";
import AdministrativeProcessesServices from "../app/components/services/administrative-processes-services";
import OperationsSTSService from "../app/components/services/operations-sts-services";
import PrivacyPolicyPage from "../app/components/misc/privacy-policy";
import TermsConditionsUsePage from "../app/components/misc/terms_conditions_use";
import OfacLicensesPage from "../app/components/licenses/ofac-licenses";

function AppRoutes() {
    return (
        <Routes>
            <Route path='/' element={<Home4Page />} />
            <Route path='/about-us' element={<CorporateIdentityPage />} />
            <Route path='/faq' element={<FaqPage />} />
            <Route path='/error404' element={<Error404Page />} />
            <Route path='/services/maritime-law' element={<MaritimeLawService />} />
            <Route path='/services/tax-law' element={<TaxLawService />} />
            <Route path='/services/customs-law' element={<CustomsLawService />} />
            <Route path='/services/commercial-law' element={<CommercialLawServices />} />
            <Route path='/services/insurance' element={<InsuranceServices />} />
            <Route path='/services/administrative-processes' element={<AdministrativeProcessesServices />} />
            <Route path='/services/operations-sts' element={<OperationsSTSService />} />
            <Route path='/services/detail' element={<ServicesDetailPage />} />
            <Route path='/blogs/grid' element={<BlogGridPage />} />
            <Route path='/blogs/detail' element={<BlogsDetailPage />} />
            <Route path='/contact-us' element={<ContactPage />} />
            <Route path='/privacy-policy' element={<PrivacyPolicyPage />} />
            <Route path='/terms-conditions-use' element={<TermsConditionsUsePage />} />
            <Route path='/ofac' element={<OfacLicensesPage />} />
            <Route path='*' element={<Error404Page/>} />
            <Route element={<Error404Page/>} />
        </Routes>
    )
}

export default AppRoutes;